baseApp.directive('notificationInner', function(){
    return {
        restrict: 'E',
        template: '<div ng-include="getContentUrl()"></div>',
        scope: {
            notification: '=',
            template: '='
        },
        link: function($scope) {
            $scope.getContentUrl = function() {
                return 'public/directives/notifications/' + $scope.template + '.html';
            };
        },
        controller: function($scope, $state, $timeout){
            $scope.socketActions = {"site":null};

            $scope.openSocketDlg = function(notification){
                    $scope.$broadcast('socket-assign-event');
            };


            $scope.assignSocket = function(socket) {
                store.save({
                    path: "/assignSiteToSocket",
                    queryParams: {
                        'siteId': $scope.socketActions.site,
                        'socketId': $scope.notification.SOCKET.id
                    },
                    success: function(data) {
                        $scope.$root.handleServerResponse(data, "" , 'Site successfully assigned to Socket');
                        if (data.status !== "ERROR" || data.notifications?.some(notification => notification.message.includes("This Socket is already assigned to a site"))) {
                            $scope.$root.closePopup('assignSiteToSocket' + '-' + $scope.notification.id);
                            $scope.notification.remove($scope.notification);
                        }
                    }
                });

            };

            $scope.rejectSocket = function() {
                store.save({
                    path: "/rejectSocket",
                    queryParams: {
                        'accountId': $state.params.accountId,
                        'socket': $scope.notification.SOCKET.id
                    },
                    success: function(data) {
                        $scope.$root.handleServerResponse(data, "" , 'Socket rejected.');
                        $scope.notification.remove($scope.notification);
                    }
                });
            };

            $scope.goToMaintenanceSettings = function(){

                let categoryId = ($scope.$root.tags.includes('SR_MANAGED_MODE')) ? "SocketMaintenance" : "Maintenance";

                $state.go('app.globalAccountConfiguration', {
                    category: categoryId
                });
            };

            $scope.rescheduleMaintenance = function(notification){
                store.fetch({
                    path: "/rescheduleMaintenance",
                    queryParams: {
                        'accountId': $state.params.accountId,
                        version: notification.socketUpgradeNotificationInfo.versionId
                    },
                    method: "POST",
                    success: function(data){
                        $scope.$root.alert(data + " sockets upgrades were rescheduled");
                        $scope.notification.remove(notification);
                    }
                });
            };

            $scope.closePopup = function(notification, elId) {
                $scope.$root.closePopup(elId + '-' + notification.id);
            };
        }
    }
});
